export default __webpack_public_path__ + "static/media/okuScreenshot@2x.2fda3b01.png";